import React from 'react';
import PropTypes from 'prop-types';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useIsMobile from '../../hooks/useIsMobile';

const FullHeightSwipeableDrawer = ({ open, onClose, title, children }) => {
  const isMobile = useIsMobile('tablet');

  return (
    <SwipeableDrawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen={!isMobile}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: 400 },
          maxWidth: { xs: '100%', sm: 400 },
          maxHeight: { xs: 700, sm: '100vh' },
          height: { xs: '90vh', sm: '100vh' },
          borderTopLeftRadius: { xs: 24, sm: 24 },
          borderTopRightRadius: { xs: 24, sm: 0 },
          borderBottomLeftRadius: { xs: 0, sm: 24 },
          backgroundColor: '#fff',
          boxShadow: 3,
          p: 0,
          right: 0,
        },
      }}
      disableBackdropTransition={!isMobile}
      disableDiscovery={!isMobile}
    >
      <Box sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'center', sm: 'center' },
          mb: 2,
        }}
        >
          {isMobile && (
            <Box
              sx={{
                width: 80,
                height: 8,
                backgroundColor: 'gray.A200',
                borderRadius: 4,
                alignSelf: 'center',
                mb: 2,
              }}
            />
          )}
          <Typography
            variant="large_1"
            sx={{
              fontWeight: 700,
              flex: { xs: 'none', sm: 1 },
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >
            {title}
          </Typography>
          {!isMobile && (
            <IconButton onClick={onClose} size="small" sx={{ ml: 1 }}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
        {children}
      </Box>
    </SwipeableDrawer>
  );
};

FullHeightSwipeableDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
};

FullHeightSwipeableDrawer.defaultProps = {
  title: '',
  children: null,
};

export default FullHeightSwipeableDrawer;
